import { Grid, Typography, Box, LinearProgress, Hidden, Button } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import AutoPlaySwipeableViews from 'src/_common/quillElements/AutoPlaySwipeableViews';
import { useEffect, useState } from 'react';
import SwipeableViews from 'react-swipeable-views';

const Drawrers = {
  FEEDBACK: 'Feedback',
  PPHR_STATISTICS: 'Statistics',
  PPHR_SETTINGS: 'Settings',
  FREEZE_WORDS: '',
  COMPARE_MODE: 'Compare Modes',
  GC_STATISTICS: 'Statistics',
  SMZR_STATISTICS: 'Statistics',
};

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    fontSize: '30px',
    textAlign: 'center',
    marginBottom: '11px',
    [theme.breakpoints.down('md')]: {
      fontSize: '23px',
      marginBottom: '13px',
    },
  },

  modeBox: {
    width: '100%',
    maxWidth: '890px',
    margin: '17px auto 26px',
    padding: '49px 30px 59px',
    textAlign: 'center',
    '& p': {
      marginBottom: '0px',
      fontSize: '28px',
      '& span': {
        color: '#E36B00', // check
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '22px',
      },
    },

    '& small': {
      fontSize: '13px',
      // color: '#828282',
      fontStyle: 'italic',
    },

    '& h3': {
      // color: theme.palette.primary.main,
      fontSize: '25px',
      fontWeight: 600,
      marginBottom: '48px',
      marginTop: '0px',

      [theme.breakpoints.down('sm')]: {
        fontSize: '22px',
        marginBottom: '0px',
      },
    },

    [theme.breakpoints.down('md')]: {
      width: '96%',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '20px 15px 20px',
      width: '96%',
    },
  },

  tabBoxHolder: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  tabBox: {
    maxWidth: '221px',
    width: '100%',
    textAlign: 'center',
    margin: '0px 20px 10px',
    position: 'relative',
    '& h4': {
      fontSize: '20px',
      fontWeight: 600,
      marginBottom: '12px',
      marginTop: '17px',

      [theme.breakpoints.down('sm')]: {
        marginBottom: '0px',
        // color: theme.palette.primary.main,
      },
    },
    '& p': {
      marginBottom: '20px',
      marginTop: '0px',
      [theme.breakpoints.down('sm')]: {
        marginTop: '10px',
      },
    },
    '& div': {
      position: 'absolute',
      bottom: '0px',
      width: '100%',
      left: '0px',
    },

    [theme.breakpoints.down('md')]: {
      maxWidth: '95%',
      margin: '20px auto',
    },
  },

  tabBoxActive: {
    '& h4': {
      color: theme.palette.primary.main,
    },
  },
  modeBoxMobile: {
    justifyContent: 'center',
  },
  colorPrimary: {
    backgroundColor: '#DCDCDC',
  },
  sliderBtn: {
    height: '60px',
    top: '50%',
    position: 'absolute',
    marginTop: '-30px',
    zIndex: 99,
  },
  mobileStepperDot: {
    backgroundColor: theme.palette.grey[50],
  },
  dotActive: {
    backgroundColor: theme.palette.primary.main,
  },
  sliderHolderMain: {
    backgroundColor: '#fff.',
    padding: '0px 0px 30px',
    [theme.breakpoints.down('md')]: {
      paddingTop: '25px',
    },
  },
}));

export function PremiumModeSliders(props: any) {
  const [progress, setProgress] = useState(0);
  const [modeTabIndex, setModeTabIndex] = useState(0);
  const classes = useStyles();

  useEffect(() => {
    const timer = setInterval(() => {
      setModeTabIndex((prevModeTabIndex) => (prevModeTabIndex === 4 ? 0 : prevModeTabIndex + 1));
    }, 5000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Grid container className={classes.sliderHolderMain}>
      <Grid item xs={12}>
        <div className="container">
          <Grid container>
            <Grid item xs={12}>
              <Typography className={classes.sectionTitle}>Premium Modes</Typography>
            </Grid>
          </Grid>
          <Hidden only={['sm', 'xs']}>
            <Grid container>
              <Grid
                item
                xs={12}
                style={{
                  position: 'relative',
                }}
              >
                <Button
                  className={classes.sliderBtn}
                  variant="text"
                  style={{
                    left: '0px',
                  }}
                  size="large"
                  onClick={() => {
                    setModeTabIndex((prevModeTabIndex) => prevModeTabIndex - 1);
                    setProgress(0);
                  }}
                  disabled={modeTabIndex === 0}
                >
                  <img src="/images/arrow.svg" alt="" style={{ transform: 'rotate(180deg)' }} />
                </Button>
                <SwipeableViews index={modeTabIndex}>
                  <Box boxShadow={3} className={classes.modeBox}>
                    <div>
                      <Typography variant="h3" color="primary">
                        Formal
                      </Typography>
                      <p>Appear calm and smart with Formal mode.</p>
                      <small>Original Text</small>
                      <p>
                        <span>Convey confidence</span> and <span>intelligence</span> with Formal
                        mode.
                      </p>
                      <small>Paraphrased Text </small>
                    </div>
                  </Box>

                  <Box boxShadow={3} className={classes.modeBox}>
                    <div>
                      <Typography variant="h3" color="primary">
                        Simple
                      </Typography>
                      <p>Ensures text is straightforward and coherent.</p>
                      <small>Original Text</small>
                      <p>
                        <span>Makes sure writing</span> is <span>clear</span> and{' '}
                        <span>understandable.</span>
                      </p>
                      <small>Paraphrased Text </small>
                    </div>
                  </Box>

                  <Box boxShadow={3} className={classes.modeBox}>
                    <div>
                      <Typography variant="h3" color="primary">
                        Creative
                      </Typography>
                      <p>Convey creativity with the biggest changes.</p>
                      <small>Original Text</small>
                      <p>
                        <span>Transmit</span> creativity with the{' '}
                        <span>greatest modifications</span>.
                      </p>
                      <small>Paraphrased Text </small>
                    </div>
                  </Box>

                  <Box boxShadow={3} className={classes.modeBox}>
                    <div>
                      <Typography variant="h3" color="primary">
                        Shorten
                      </Typography>
                      <p>Helps to make sure you keep your text short.</p>
                      <small>Original Text</small>
                      <p>Helps you keep your text short.</p>
                      <small>Paraphrased Text </small>
                    </div>
                  </Box>

                  <Box boxShadow={3} className={classes.modeBox}>
                    <div>
                      <Typography variant="h3" color="primary">
                        Expand
                      </Typography>
                      <p>Make your writing longer.</p>
                      <small>Original Text</small>
                      <p>
                        <span> Add more words to expand your writing.</span>
                      </p>
                      <small>Paraphrased Text </small>
                    </div>
                  </Box>
                </SwipeableViews>
                <Button
                  className={classes.sliderBtn}
                  size="large"
                  style={{
                    right: '0px',
                  }}
                  onClick={() => {
                    setModeTabIndex((prevModeTabIndex) => prevModeTabIndex + 1);
                    setProgress(0);
                  }}
                  disabled={modeTabIndex === 4}
                >
                  <img src="/images/arrow.svg" alt="arrow" />
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Box className={classes.tabBoxHolder}>
                  <Box
                    className={`${classes.tabBox} ${
                      modeTabIndex === 0 ? classes.tabBoxActive : ''
                    }`}
                  >
                    <h4>Formal</h4>
                    <p>Presents text in a more sophisticated and professional way</p>
                  </Box>
                  <Box
                    className={`${classes.tabBox} ${
                      modeTabIndex === 1 ? classes.tabBoxActive : ''
                    }`}
                  >
                    <h4>Simple</h4>
                    <p>Presents text in a way most people can understand</p>
                  </Box>
                  <Box
                    className={`${classes.tabBox} ${
                      modeTabIndex === 2 ? classes.tabBoxActive : ''
                    }`}
                  >
                    <h4>Creative</h4>
                    <p>Expresses ideas in a completely new way that may change the meaning </p>
                  </Box>
                  <Box
                    className={`${classes.tabBox} ${
                      modeTabIndex === 3 ? classes.tabBoxActive : ''
                    }`}
                  >
                    <h4>Shorten</h4>
                    <p>Strips away extra words to provide a clear message </p>
                  </Box>
                  <Box
                    className={`${classes.tabBox} ${
                      modeTabIndex === 4 ? classes.tabBoxActive : ''
                    }`}
                  >
                    <h4>Expand</h4>
                    <p>Adds more detail and depth to increase sentence length</p>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Hidden>
          <Hidden only={['lg', 'md', 'xl']}>
            <Grid container>
              <Grid
                item
                xs={12}
                style={{
                  position: 'relative',
                }}
              >
                <AutoPlaySwipeableViews
                  autoplay={true}
                  // showControlOnEnd
                  // showBottomControl
                  mobileStepperClasses={{
                    //  dot: classes.mobileStepperDot,
                    dotActive: classes.dotActive,
                  }}
                  mobileStepperStyle={{ backgroundColor: 'transparent' }}
                  mobileStepperContainerStyle={{
                    position: 'static',
                  }}
                  controlBtnStyle={{
                    display: 'none',
                  }}
                >
                  <Box className={classes.modeBoxMobile}>
                    <Box boxShadow={3} className={classes.modeBox}>
                      <div>
                        <Typography variant="h3" color="primary">
                          Formal
                        </Typography>
                        <p>Appear calm and smart with Formal mode.</p>
                        <small>Original Text</small>
                        <p>
                          <span>Convey confidence</span> and <span>intelligence</span> with Formal
                          mode.
                        </p>
                        <small>Paraphrased Text </small>
                      </div>
                    </Box>

                    <Box className={classes.tabBox}>
                      <Typography variant="h4" color="primary">
                        Formal
                      </Typography>
                      <p>Presents text in a more sophisticated and professional way</p>
                    </Box>
                  </Box>
                  <Box className={classes.modeBoxMobile}>
                    <Box boxShadow={3} className={classes.modeBox}>
                      <div>
                        <Typography variant="h3" color="primary">
                          Simple
                        </Typography>
                        <p>Ensures text is straightforward and coherent.</p>
                        <small>Original Text</small>
                        <p>
                          <span>Makes sure writing</span> is <span>clear</span> and{' '}
                          <span>understandable.</span>
                        </p>
                        <small>Paraphrased Text </small>
                      </div>
                    </Box>

                    <Box className={classes.tabBox}>
                      <Typography variant="h4" color="primary">
                        Simple
                      </Typography>
                      <p>Presents text in a way most people can understand</p>
                    </Box>
                  </Box>
                  <Box className={classes.modeBoxMobile}>
                    <Box boxShadow={3} className={classes.modeBox}>
                      <div>
                        <Typography variant="h3" color="primary">
                          Creative
                        </Typography>
                        <p>Convey creativity with the biggest changes.</p>
                        <small>Original Text</small>
                        <p>
                          <span>Transmit</span> creativity with the{' '}
                          <span>greatest modifications</span>.
                        </p>
                        <small>Paraphrased Text </small>
                      </div>
                    </Box>

                    <Box className={classes.tabBox}>
                      <Typography variant="h4" color="primary">
                        Creative
                      </Typography>
                      <p>Expresses ideas in a completely new way that may change the meaning</p>
                    </Box>
                  </Box>
                  <Box className={classes.modeBoxMobile}>
                    <Box boxShadow={3} className={classes.modeBox}>
                      <div>
                        <Typography variant="h3" color="primary">
                          Shorten
                        </Typography>
                        <p>Helps to make sure you keep your text short.</p>
                        <small>Original Text</small>
                        <p>Helps you keep your text short.</p>
                        <small>Paraphrased Text </small>
                      </div>
                    </Box>

                    <Box className={classes.tabBox}>
                      <Typography variant="h4" color="primary">
                        Shorten
                      </Typography>
                      <p>Strips away extra words to provide a clear message</p>
                    </Box>
                  </Box>
                  <Box className={classes.modeBoxMobile}>
                    <Box boxShadow={3} className={classes.modeBox}>
                      <div>
                        <Typography variant="h3" color="primary">
                          Expand
                        </Typography>
                        <p>Make your writing longer.</p>
                        <small>Original Text</small>
                        <p>
                          Add more words to expand <span>your writing.</span>
                        </p>
                        <small>Paraphrased Text </small>
                      </div>
                    </Box>

                    <Box className={classes.tabBox}>
                      <Typography variant="h4" color="primary">
                        Expand
                      </Typography>
                      <p>Adds more detail and depth to increase sentence length</p>
                    </Box>
                  </Box>
                </AutoPlaySwipeableViews>
              </Grid>
            </Grid>
          </Hidden>
        </div>
      </Grid>
    </Grid>
  );
}
